{
  "slug": "highest-iq-ever-recorded",
  "title": "ما هو أعلى معدل ذكاء مسجل على الإطلاق؟",
  "description": "فحص الادعاءات الشهيرة بأعلى معدلات الذكاء، وسقف الاختبار، ومقاييس الدرجات غير المتوافقة، ولماذا لا يوجد ترتيب عالمي نهائي علمي.",
  "summary": "لا توجد إجابة واحدة مبررة على السؤال حول أعلى معدل ذكاء. فمن الصعب تقدير الدرجات العالية للغاية، وتستخدم الاختبارات مقاييس وسقفاً مختلفين، والعديد من الادعاءات الشهيرة تفتقر إلى تقرير موثوق به.",
  "category": "تفسير معدل الذكاء",
  "sections": [
    {
      "heading": "باء - لماذا لا يمكن مقارنة المطالبات المسجلة مباشرة",
      "paragraphs": [
        "إن رقم معدل الذكاء لا يحمل أي معنى إلا فيما يتصل بالآلة المسماة، والطبعة، ومعيار السن، ونوع النتيجة، والإدارة. ولا يمكن ترتيب نتيجة من مقياس مباشرة مقارنة بعدد من مقياس آخر دون تحويل مبرر.",
        "حسابات نسبة الذكاء القديمة، وعلامات الانحراف الحديثة، ونتائج الطفولة، والمعايير الموسعة، والاختبارات غير المراقبة غالبا ما يتم خلطها في قوائم شعبية حتى وإن كانت تجيب على أسئلة قياس مختلفة."
      ]
    },
    {
      "heading": "وتتسم الدرجات المتطرفة بدرجة أكبر من عدم اليقين",
      "paragraphs": [
        "وتتضمن الاختبارات عددا محدودا من البنود ونطاقا محدودا من الصعوبة، وقرب الحد الأقصى، قد ينتج اختلاف صغير في الدرجات الأولية اختلافا كبيرا في التقارير، وتحتوي العينة المرجعية على عدد قليل نسبيا من الملاحظات القابلة للمقارنة.",
        "ولذلك ينبغي تفسير القيمة التي تبدو دقيقة في ذيل التحليل الطرفي مع مراعاة فترات الثقة والقيود التقنية، فالقيم المستقطة لا تعادل الدرجات المدعومة مباشرة."
      ]
    },
    {
      "heading": "كيف تقيِّم ادعاءً مشهوراً",
      "paragraphs": [
        "لذا، فمن الأفضل أن نبحث عن تقرير أولي يذكر اسم الاختبار، والطبعة، والتاريخ، والعمر، والظروف، والمجموعة المعيارية، والنتيجة. والاقتباس المتكرر عبر المقالات المدرجة في القائمة دون ذلك الدليل لا يصبح مؤكدا من خلال التكرار.",
        "من المعقول أن نصف الإنجازات الموثقة. وليس من المسؤولية العلمية أن نحول الإنجاز أو التعليم أو السلوك الخيالي إلى رقم دقيق لمعدل الذكاء."
      ]
    }
  ],
  "faqs": [
    {
      "question": "معدل الذكاء 200 ممكن؟",
      "answer": "ويمكن أن يظهر رقم ما في إطار بعض طرق التقدير التاريخية أو الموسعة، ولكن معناه ودقته يتوقفان كليا على الصك والمعايير."
    },
    {
      "question": "من لديه أعلى معدل ذكاء اليوم؟",
      "answer": "ولا يوجد ترتيب عالمي شامل قابل للمقارنة ومحقق من جانب مستقل فيما يتعلق بالعديد من الاختبارات ومقاييس الدرجات."
    }
  ],
  "related": ["iq-160-meaning", "how-is-iq-measured", "albert-einstein-iq"],
  "sources": [
    {
      "label": "قاموس علم النفس - IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "بيرسون - وايس -5 تقرير تقييم العينة",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
